<template>
    <div>
        <SettingsList ref="child" :title="$t('services.plural')" :headers="headers" :items="items"
                      :loading="loading" :url="url" :add_button_title="$t('services.create')"
                      :delete_text="$t('services.delete')"
                      :delete_confirmation_text="$t('services.delete_confirmation')" @show-dialog="showDialog"
                      @view-dialog="showDialog" @update-dialog="showDialog" @get-data="getData">
        </SettingsList>

        <!--Tag Dialog-->
        <Dialog :show="show_item_dialog" max_width="50%" :header="item_dialog_header"
                :is_loading="item_dialog_loading" :action="item_action" @close-dialog="closeItemDialog"
                @submit-dialog="submitItemDialog">
            <template slot="content">
                <v-form autocomplete="off" class="white_bg_form">
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field name="description" type="text" class="custom_field" v-model="item.description"
                                          :label="$t('general.description')" outlined clearable :disabled="isDisabled"
                                          @input="$v.item.description.$touch()" @blur="$v.item.description.$touch()"
                                          :error-messages="fieldErrors('description')"
                                          @keyup="$Helper.methods.uppercase">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="4">
                            <v-text-field name="price" type="number" class="custom_field" v-model="item.price"
                                          :label="$t('general.price')" outlined clearable :disabled="isDisabled"
                                          @input="$v.item.price.$touch()" @blur="$v.item.price.$touch()"
                                          :error-messages="fieldErrors('price')" prefix="€">
                            </v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field name="duration" type="number" class="custom_field" v-model="item.duration"
                                          :label="$t('general.duration')" outlined clearable :disabled="isDisabled"
                                          @input="$v.item.duration.$touch()" @blur="$v.item.duration.$touch()"
                                          :error-messages="fieldErrors('duration')">
                            </v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-select name="vat_value" v-model="item.vat_id" class="custom_field" outlined
                                      :items="vats" :label="$t('general.vat')" item-text="vat_value"
                                      :disabled="isDisabled"
                                      item-value="id" outlined>
                                <template slot="selection" slot-scope="data">
                                    <!-- HTML that describe how select should render selected items -->
                                    {{ data.item.vat_value }} %
                                </template>
                                <template slot="item" slot-scope="data">
                                    <!-- HTML that describe how select should render items when the select is open -->
                                    {{ data.item.vat_value }} %
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </Dialog>
    </div>
</template>

<script>
    import SettingsList from '../../components/SettingsList.vue'
    import Dialog from '../../components/Dialog.vue'
    import {validationMixin} from 'vuelidate'
    import {required, numeric} from 'vuelidate/lib/validators'

    export default {
        components: {
            SettingsList, Dialog
        },
        mixins: [validationMixin],
        validations: {
            item: {
                description: {required},
                price: {required},
                duration: {required, numeric},
            }
        },
        data: self => ({
            vats: [],
            // datatable
            headers: [],
            items: [],
            loading: false,
            url: 'service',

            // dialog
            show_item_dialog: false,
            item_dialog_header: null,
            item_dialog_loading: false,
            item: {
                description: null,
                price: null,
                duration: 30,
                vat_id: 1
            },
            item_id: null,
            item_action: null
        }),
        computed: {
            isDisabled() {
                return this.item_action === 'view';
            },
            locale() {
                return this.$i18n.locale;
            }
        },
        created() {
            this.headers = this.getHeaders();
        },
        async mounted() {
            this.getData();

            let response = await this.$store.dispatch('apiRequest', {
                method: 'get', url: 'settings/vats'
            });
            this.vats = response.data;
        },
        watch: {
            locale(val) {
                this.headers = this.getHeaders();
            }
        },
        methods: {
            // return headers array
            getHeaders() {
                return [
                    {text: `${this.$t('general.description')}`, value: 'description', sortable: true},
                    {text: `${this.$t('general.price')} €`, value: 'price', sortable: true},
                    {text: `${this.$t('general.duration')}`, value: 'duration', sortable: true},
                    {text: `${this.$t('general.vat')}`, value: 'vat_value', sortable: true},
                    {text: `${this.$t('datatable.actions')}`, value: 'actions', align: 'right', sortable: false}
                ];
            },

            // form field errors
            fieldErrors(prop) {
                const errors = [];
                if (!this.$v.item[prop].$dirty) return errors;
                !this.$v.item[prop].required && errors.push(this.$t('validation.required'));
                return errors;
            },
            // get data from API
            async getData() {
                this.loading = true;
                let response = await this.$store.dispatch('apiRequest', {
                    method: 'get',
                    url: `${this.url}/index`
                });

                // successful response
                if (!response.response) {
                    this.items = response.data;
                }

                this.loading = false;
            },
            // show item dialog
            showDialog(item, action) {
                this.show_item_dialog = true;
                this.item_action = action;
                this.item_dialog_header = action === 'create' ? this.$t('services.create') :
                    action === 'view' ? this.$t('services.view') : this.$t('services.update');

                if (item) {
                    this.setItemInfo(item);
                }
            },
            // set item info for update and view
            setItemInfo(item) {
                this.item_id = item.id;

                for (let prop in this.item) {
                    this.item[prop] = item[prop];
                }
            },
            // close item dialog
            closeItemDialog() {
                this.$v.item.$reset();
                this.show_item_dialog = false;
                this.item_id = null;
                this.item_action = null;

                for (let prop in this.item) {
                    this.item[prop] = null;
                }
                this.item['vat_id'] = 1;
            },
            // submit item dialog
            async submitItemDialog() {
                this.$v.item.$touch();

                // login data are valid
                if (!this.$v.item.$invalid) {
                    this.item_dialog_loading = true;
                    let item = Object.assign({}, this.item);

                    let response = await this.$refs.child.submitItem(item, this.item_id);

                    // stop dialog submit button loading
                    this.item_dialog_loading = false;

                    // successful response
                    if (!response.response) {

                        // close item dialog
                        this.closeItemDialog();

                        // get items
                        this.getData();
                    }
                }
            }
        }
    }
</script>